export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10979.369ce96d.jpg";